import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import authReducer from '../auth/authSlice';
import comprovanteReducer from '../features/Comprovante/comprovanteSlice';
import consultaCompletaReducer from '../features/ConsultaCompleta/consultaCompletaSlice';
import consultaSimplesReducer from '../features/ConsultaSimples/consultaSimplesSlice';
import identificacaoPositivaReducer from '../features/IdentificacaoPositiva/identificacaoPositivaSlice';
import perfilReducer from '../features/Perfil/perfilSlice';
import postoAtendimentoReducer from '../features/PostoAtendimento/PostoAtendimentoSlice';
import preCadastroReducer from '../features/PreCadastro/preCadastroSlice';
import consultaPreCadastroReducer from '../features/PreCadastro/ConsultaPreCadastro/consultaPreCadastroSlice';
import termoDeUsoReducer from '../features/TermoDeUso/termoDeUsoSlice';
import validacaoComprovanteReducer from '../features/ValidacaoComprovante/validacaoComprovanteSlice';
import atualizacaoCadastralReducer from '../features/AtualizacaoCadastralPorConfirmacao/atualizacaoCadastralSlice';
import caixaMensagemReducer from '../features/CaixaMensagem/CaixaMensagemSlice';
import caixaMensagemDetalheReducer from '../features/CaixaMensagemDetalhe/CaixaMensagemDetalheSlice';
import beneficiosReducer from '../features/Beneficios/BeneficiosSlice';
import consultaCpfReducer from '../features/ConsultaCpf/consultaCpfSlice';
import suporteReducer from '../features/Suporte/SuporteSlice';
import consultaRendaReducer from '../features/ConsultaRenda/consultaRendaSlice';
import exclusaoCadastralReducer from '../features/ExclusaoCadastral/exclusaoCadastralSlice';
import dadosBasicosReducer from '../components/DadosBasicos/dadosBasicosSlice';
import consultaPendenciasReducer from '../features/ConsultaPendencias/consultaPendenciasSlice';
import exclusaoPorObitoReducer from '../features/ExclusaoPorObito/exclusaoPorObitoSlice';
import consultaEscolaridadeReducer from '../features/ConsultaEscolaridade/consultaEscolaridadeSlice';
import programasSociaisReducer from '../features/ProgramasSociais/ProgramasSociaisSlice'
import carteiraDocumentosReducer from '../features/CarteiraDocumentos/carteiraDocumentosSlice';
import globalReducer from '../globalSlice';

export const store = configureStore({
  reducer: {
    global: globalReducer,
    auth: authReducer,
    consultaCompleta: consultaCompletaReducer,
    validacaoComprovante: validacaoComprovanteReducer,
    comprovante: comprovanteReducer,
    identificacaoPositiva: identificacaoPositivaReducer,
    consultaSimples: consultaSimplesReducer,
    postoAtendimento: postoAtendimentoReducer,
    perfil: perfilReducer,
    termoDeUso: termoDeUsoReducer,
    preCadastro: preCadastroReducer,
    atualizacaoCadastral: atualizacaoCadastralReducer,
    consultaPreCadastro: consultaPreCadastroReducer,
    caixaMensagem: caixaMensagemReducer,
    caixaMensagemDetalhe: caixaMensagemDetalheReducer,
    beneficios: beneficiosReducer,
    consultaCpf: consultaCpfReducer,
    suporte: suporteReducer,
    consultaRenda: consultaRendaReducer,
    exclusaoCadastral: exclusaoCadastralReducer,
    dadosBasicos: dadosBasicosReducer,
    consultaPendencias: consultaPendenciasReducer,
    exclusaoPorObito: exclusaoPorObitoReducer,
    consultaEscolaridade: consultaEscolaridadeReducer,
    programasSociais: programasSociaisReducer,
    carteiraDocumentos: carteiraDocumentosReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
